import Icon from "../Icon";
import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";
import * as types from "./constants";

const FaceEmoji = ({ type, className }) => (
  <div className={classnames(styles.container, className)}>
    <Icon icon={"emoji-face"} className={styles.face} />
    <Icon icon={`emoji-${type}`} className={styles.features} />
  </div>
);

FaceEmoji.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  className: PropTypes.string
};

export default FaceEmoji;
